import type { ReaderChapterMeta } from '@bookclub/shared';
import { MiniappSurface } from '@/shared/components/ui/MiniappSurface';
import { SectionHeader } from '@/shared/components/ui/SectionHeader';
import { EmptyState } from '@/shared/components/ui/EmptyState';
import { ChapterRow } from '@/shared/components/club/ChapterRow';

interface ReaderTocProps {
  chapters: ReaderChapterMeta[];
  currentChapterId: string;
  onSelect: (chapter: ReaderChapterMeta) => void;
}

export function ReaderToc({ chapters, currentChapterId, onSelect }: ReaderTocProps) {
  if (chapters.length === 0) {
    return (
      <EmptyState
        eyebrow="Главы"
        title="Главы пока не подготовлены"
        description="Когда главы появятся, они будут доступны в этом списке."
      />
    );
  }

  return (
    <MiniappSurface className="space-y-4 rounded-[30px] bg-[rgba(255,252,247,0.98)] p-4 shadow-none min-[430px]:p-5">
      <SectionHeader
        label="Главы"
        meta={`${chapters.length}`}
        description="Выбор главы с сохранением текущего контекста чтения."
      />
      <div className="space-y-2.5">
        {chapters
          .slice()
          .sort((a, b) => a.index - b.index)
          .map((chapter) => (
            <ChapterRow
              key={chapter.id}
              chapter={{
                id: chapter.id,
                index: chapter.index,
                title: chapter.title,
                access: chapter.access,
              }}
              active={chapter.id === currentChapterId}
              onTap={() => onSelect(chapter)}
            />
          ))}
      </div>
    </MiniappSurface>
  );
}
